import { Box, Divider, SimpleGrid } from '@hover/blueprint';
import React from 'react';
import { HOW_HOVER_WORKS_LIST_DATA } from '../../../constants';
import { SwitcherDesktopItem } from '../../common';

interface Props {
  currentTab: number;
  setCurrentTab: React.Dispatch<React.SetStateAction<number>>;
}

const Desktop: React.FC<Props> = ({ currentTab, setCurrentTab }) => (
  <SimpleGrid
    w="100%"
    d={{ base: 'none', desktop: 'grid' }}
    columns={2}
    alignItems="center"
    spacing={700}
  >
    <Box maxW="480px" h="100%" w="100%" flexDir="column">
      <Divider
        borderColor="red.100"
        borderWidth="1px"
        borderTopWidth={0}
        my={0}
        d={currentTab === 0 ? 'none' : 'block'}
      />
      {HOW_HOVER_WORKS_LIST_DATA.map(listItem => (
        <SwitcherDesktopItem
          key={listItem.id}
          activeBackground="red.100"
          body={listItem.body}
          borderColor="red.100"
          currentTab={currentTab}
          isLast={listItem.id === HOW_HOVER_WORKS_LIST_DATA.length - 1}
          itemIndex={listItem.id}
          setCurrentTab={setCurrentTab}
          title={listItem.title}
          titleColor="red.500"
        />
      ))}
    </Box>
    {HOW_HOVER_WORKS_LIST_DATA.map(listItem => (
      <Box
        key={listItem.id}
        d={listItem.id === currentTab ? 'flex' : 'none'}
        alignItems="center"
        justifyContent="center"
        w="100%"
        maxH="355px"
      >
        <Box maxH="355px" minH="355px">
          {listItem.desktopImage}
        </Box>
      </Box>
    ))}
  </SimpleGrid>
);

export default Desktop;
